/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";
import { ContentZoneContext } from "cms/components/context";
import { useGetCurrentWebpage } from "hooks/useGetCurrentWebpage";
import { NavigationListSection } from "./section-list";
import { useContext } from "react";
import { useSelector } from "react-redux";

const NavigationListComponentDisplay = () => {
    
    const ctx = useContext(ContentZoneContext);
    const website = useSelector((state) => state.website.current);
    const { home } = website || {};
    const webpage = useGetCurrentWebpage();
    const { guid, parent } = webpage || {};
    const { component } = ctx || {};
    const { description } = component || {};
    const parent_guid = parent?.guid;
    const hasParent = !!parent_guid;
    const isSection = hasParent && (parent_guid === home);

    return (
        <div className='simplicity-section-list'>
            {webpage &&
                <>
                    {!isSection &&
                        <RichTextPreview
                            richtext={description}
                        />
                    }
                    <NavigationListSection
                        webpage_id={guid}
                    />
                </>
            }
        </div>
    );
};

NavigationListComponentDisplay.displayname = "NavigationListComponentDisplay";
export { NavigationListComponentDisplay };
